import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=38659118&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38659118')) {
      api.createRecord('38659118', component.options)
    } else {
      api.reload('38659118', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=38659118&", function () {
      api.rerender('38659118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WN7Nc6LG93E8/JS/pricehelp.vue"
export default component.exports